import type { FeaturedPostsSection } from "@/data/types";
import { resolveImagePath } from "@/utils/imageMap";

interface FeaturedPostsProps {
  data: FeaturedPostsSection;
}

export function FeaturedPosts({ data }: FeaturedPostsProps) {
  return (
    <section id="featured" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {data.title}
          </h2>
        </header>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {data.posts.map((post, index) => (
            <article key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              {post.image && (
                <div className="h-48 overflow-hidden">
                  <img
                    src={resolveImagePath(post.image)}
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              )}
              
              <div className="p-6">
                <h3 className="font-semibold text-lg text-gray-900 mb-3 line-clamp-2">
                  <a 
                    href={post.href} 
                    className="hover:text-blue-600 transition-colors duration-200"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {post.title}
                  </a>
                </h3>
                
                <p className="text-gray-600 text-sm line-clamp-3 mb-4">
                  {post.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}